import { render, staticRenderFns } from "./UsersBaseForm.vue?vue&type=template&id=76fbf557&"
import script from "./UsersBaseForm.vue?vue&type=script&lang=js&"
export * from "./UsersBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports